import { useEffect, useState } from "react";
import { getRouteCarForTotalTime } from "../../../../actions/navitimeAPI";
import { generateDurationOptions, getCoordinate, getTotalTime } from "../utils";

export function useDuration({ transferType, pickupLocationData, dropoffLocationData, lang }) {
    const [duration, setDuration] = useState(
        lang === "EN" || lang === "en"
            ? { label: "03 Hours 00 Minutes", value: "03:00" }
            : { label: "03時間 00分", value: "03:00" }
    );
    const [durationOptions, setDurationOptions] = useState([]);

    // Initialize duration options
    useEffect(() => {
        setDurationOptions(generateDurationOptions(lang, 0));
    }, [lang]);

    // Update duration options based on route distance
    useEffect(() => {
        const checkTotalTimeForDuration = async () => {
            if (transferType !== "charter") return;

            const pickupLat = getCoordinate(pickupLocationData, "lat");
            const pickupLon = getCoordinate(pickupLocationData, "lon");
            const dropoffLat = getCoordinate(dropoffLocationData, "lat");
            const dropoffLon = getCoordinate(dropoffLocationData, "lon");

            if (
                [pickupLat, pickupLon, dropoffLat, dropoffLon].some(
                    (value) => value === null || value === undefined
                )
            ) {
                return;
            }

            try {
                const start = `${pickupLat}%2C${pickupLon}`;
                const end = `${dropoffLat}%2C${dropoffLon}`;
                const carRoutes = await getRouteCarForTotalTime(start, end);
                const totalTime = getTotalTime(carRoutes);

                if (typeof totalTime !== "number") return;

                const nextOptions = generateDurationOptions(lang, totalTime);
                setDurationOptions(nextOptions);
                setDuration((prevDuration) => {
                    const selectedDurationValue = prevDuration?.value;
                    const isSelectedStillValid = nextOptions.some(
                        (option) => option.value === selectedDurationValue
                    );
                    if (isSelectedStillValid) return prevDuration;
                    return nextOptions[0] || prevDuration;
                });
            } catch (error) {
                console.error("Error loading usage duration options:", error);
            }
        };

        checkTotalTimeForDuration();
    }, [transferType, pickupLocationData, dropoffLocationData, lang]);

    return {
        duration,
        setDuration,
        durationOptions,
    };
}
